function isDataGroup(object) {
  return Object.prototype.hasOwnProperty.call(object, 'shape') && Object.prototype.hasOwnProperty.call(object, 'series');
}
function isDataGroupArray(array) {
  if (array.length > 0) {
    const [group] = array;
    return isDataGroup(group);
  }

  return false;
}

export { isDataGroup, isDataGroupArray };
